import { Fragment } from 'react';
import PropTypes from 'prop-types'
import compose from 'lodash/flowRight';
import Typography from '@material-ui/core/Typography';
import { graphql } from '@apollo/client/react/hoc';
import Loading from '../loading';
import ErrorMessage from '../error-message';
import NotFound from '../not-found';
import MemberList from './member-list';
import { groupMembersQuery } from '../../apollo/groups';

const GroupMembersTab = ({ loading, error, group }) => {
  if (error) {
    return <ErrorMessage message='An error occurred while loading members.' error={error} compact />;
  }
  if (loading) { return <Loading compact />; }
  if (!group) { return <NotFound compact />; }

  return (
    <Fragment>
      <Typography variant="h2">Members</Typography>
      <MemberList members={group.members} group={group} />
    </Fragment>
  );
};

GroupMembersTab.propTypes = {
  group: PropTypes.object,
  loading: PropTypes.bool,
  error: PropTypes.object
};

export default compose(
  graphql(groupMembersQuery, {
    props: ({ data: { group, loading, error } }) => {
      return {
        group,
        loading,
        error
      };
    },
    options: ({ group }) => ({
      variables: {
        slug: group.slug
      }
    })
  })
)(GroupMembersTab);
